// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:29:32Z                      #

// ##############################################################

/**
 * Určuje typ kontaktu.
 */

/**
 * Adresa.
 */
export const ADR = 'ADR';

/**
 * Adresa trvalého pobytu/sídla.
 */
export const ADRTRVSDL = 'ADRTRVSDL';

/**
 * Doručovací adresa z registrů.
 */
export const ADRDORREG = 'ADRDORREG';

/**
 * Kontaktní doručovací adresa.
 */
export const ADRDOR = 'ADRDOR';

/**
 * Datová schránka.
 */
export const DS = 'DS';

/**
 * E-mail.
 */
export const EMAIL = 'EMAIL';

/**
 * Telefon.
 */
export const TEL = 'TEL';

/**
 * Kontaktní osoba.
 */
export const OSOBA = 'OSOBA';

/**
 * Seznam všech hodnot.
 */
export const values = [
    ADR,
    ADRTRVSDL,
    ADRDORREG,
    ADRDOR,
    DS,
    EMAIL,
    TEL,
    OSOBA
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [ADR]: {caption: 'Adresa.'},
    [ADRTRVSDL]: {caption: 'Adresa trvalého pobytu/sídla.'},
    [ADRDORREG]: {caption: 'Doručovací adresa z registrů.'},
    [ADRDOR]: {caption: 'Kontaktní doručovací adresa.'},
    [DS]: {caption: 'Datová schránka.'},
    [EMAIL]: {caption: 'E-mail.'},
    [TEL]: {caption: 'Telefon.'},
    [OSOBA]: {caption: 'Kontaktní osoba.'}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}